var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Emit, Prop, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
var EditSectionForm = /** @class */ (function (_super) {
    __extends(EditSectionForm, _super);
    function EditSectionForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = '';
        return _this;
    }
    EditSectionForm.prototype.mounted = function () {
        this.sectionUpdated();
    };
    EditSectionForm.prototype.sectionUpdated = function () {
        var _this = this;
        if (this.section) {
            // db.getReference(`${this.configName}/${this.section}`)
            //   .once('value', snapshot => this.title = snapshot.val().title);
            this.config
                .child(this.section)
                .child('title')
                .ref.once('value', function (snapshot) { return _this.title = snapshot.val(); });
        }
        else {
            this.title = '';
        }
    };
    EditSectionForm.prototype.saveSection = function () {
        if (this.section) {
            // db.getReference(`${this.configName}/${this.section}`)
            //   .set({title: this.title});
            this.config
                .child(this.section)
                .child('title')
                .ref.set(this.title);
        }
        else {
            // db.getReference(this.configName)
            //   .push({title: this.title});
            this.config.ref.push({ title: this.title });
        }
    };
    EditSectionForm.prototype.removeSection = function () {
        // db.getReference(`${this.configName}/${this.section}`).remove();
        this.config
            .child(this.section)
            .ref.remove();
    };
    EditSectionForm.prototype.cancel = function () {
        this.$emit('close');
    };
    __decorate([
        Prop()
    ], EditSectionForm.prototype, "section", void 0);
    __decorate([
        Prop()
    ], EditSectionForm.prototype, "configName", void 0);
    __decorate([
        Prop()
    ], EditSectionForm.prototype, "config", void 0);
    __decorate([
        Watch('section')
    ], EditSectionForm.prototype, "sectionUpdated", null);
    __decorate([
        Emit('close')
    ], EditSectionForm.prototype, "saveSection", null);
    __decorate([
        Emit('close')
    ], EditSectionForm.prototype, "removeSection", null);
    EditSectionForm = __decorate([
        Component
    ], EditSectionForm);
    return EditSectionForm;
}(Vue));
export default EditSectionForm;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/EditSectionForm.vue
// module id = 196
// module chunks = 0